export default () => {
  const parameters = {}
  const search = decodeURIComponent(location.search.substring(1))

  search.split('&').forEach((raw) => {
    const key = raw.split('=')[0]
    const value = raw.split('=')[1]
    if (key.includes('[')) {
      const splittedKey = key.split('[')
      const parentKey = splittedKey[0]
      const childKey = splittedKey[1].substring(0, splittedKey[1].length - 1)
      if (parameters[parentKey] === undefined) {
        parameters[parentKey] = {}
      }
      parameters[parentKey][childKey] = value
    } else {
      parameters[key] = value
    }
  })
  return parameters
}
